import { Badge } from '@shared/ui/Badge';
import type { Source, TargetEntityOption } from './types';

export const DOC_TYPES = [
  // Технические нормативы — для compliance-проверки проектной документации
  { value: 'gost', label: 'ГОСТ' },
  { value: 'snip', label: 'СНиП' },
  { value: 'sp', label: 'СП' },
  { value: 'tu', label: 'ТУ' },
  // Юридические источники — для «точность ссылок ≥ 99,5%».
  // Подтягиваются RAG-ом при экспертизе договоров.
  { value: 'code', label: 'Кодекс (ГК, ГрК, АПК, ГПК, НК)' },
  { value: 'fz', label: 'Федеральный закон' },
  { value: 'plenum', label: 'Постановление Пленума' },
  // Внутренние документы компании
  { value: 'internal', label: 'Внутренний документ' },
  // Шаблоны для ОСНОВА.Шаблонизатор (ADR-0001). DOCX с шапкой и логотипом
  // САТКОМ — агент позже подберёт ближайший и перепишет тело под факты.
  { value: 'template_response_claim', label: 'Шаблон ответа на претензию' },
  { value: 'template_outgoing_claim', label: 'Шаблон исходящей претензии' },
  { value: 'template_protocol_disagreement', label: 'Шаблон протокола разногласий' },
  { value: 'template_lawsuit', label: 'Шаблон искового заявления' },
  // Регламенты проверки (чек-листы). Агент извлекает из них правила и
  // показывает юристу «что запомнил» (см. ChecklistRulesModal).
  { value: 'checklist', label: 'Правила анализа (чек-лист)' },
];

// 4 типа шаблонов исходящих для ОСНОВА.Шаблонизатор. Порядок = порядок
// карточек-слотов на вкладке «Шаблоны исходящих».
export const RESPONSE_TEMPLATE_TYPES: { value: string; label: string }[] = [
  { value: 'template_response_claim', label: 'Ответ на претензию' },
  { value: 'template_outgoing_claim', label: 'Исходящая претензия' },
  { value: 'template_protocol_disagreement', label: 'Протокол разногласий' },
  { value: 'template_lawsuit', label: 'Исковое заявление' },
];

// document_type → template_kind для multipart-поля upload-запроса.
// Backend требует префикс template_, если передан template_kind — справочно
// дублируем здесь чтобы UI не давал юристу залить ГОСТ как «шаблон ответа».
export const TEMPLATE_KIND_BY_DOC_TYPE: Record<string, string> = {
  template_response_claim: 'response_claim',
  template_outgoing_claim: 'outgoing_claim',
  template_protocol_disagreement: 'protocol_disagreement',
  template_lawsuit: 'lawsuit',
};

export const TARGET_ENTITY_OPTIONS: { value: TargetEntityOption; label: string }[] = [
  { value: 'any', label: 'Любой адресат' },
  { value: 'contractor', label: 'Подрядчик' },
  { value: 'customer', label: 'Заказчик' },
  { value: 'gov', label: 'Госорган' },
];

export function statusBadge(s: string) {
  switch (s) {
    case 'active':
      return <Badge $tone="success">Активен</Badge>;
    case 'processing':
      return <Badge $tone="info">Индексация</Badge>;
    case 'failed':
      return <Badge $tone="danger">Ошибка</Badge>;
    case 'archived':
      return <Badge $tone="neutral">Архив</Badge>;
    default:
      return <Badge>{s}</Badge>;
  }
}

export function fmtSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} Б`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} КБ`;
  return `${(bytes / 1024 / 1024).toFixed(1)} МБ`;
}

export function fmtDate(iso: string): string {
  return new Date(iso).toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export const SOURCE_TABS: { value: Source; label: string }[] = [
  { value: '', label: 'Все источники' },
  { value: 'tech', label: 'ГОСТы и СНиП' },
  { value: 'legal', label: 'НПА (кодексы, ФЗ, постановления)' },
  { value: 'internal', label: 'Внутренние документы' },
  { value: 'template', label: 'Эталонные формы договоров' },
  { value: 'response', label: 'Шаблоны исходящих документов' },
  { value: 'rules', label: 'Правила анализа' },
];

export const SOURCE_TYPES: Record<Exclude<Source, '' | 'template'>, string[]> = {
  tech: ['gost', 'snip', 'sp', 'tu'],
  legal: ['code', 'fz', 'plenum'],
  internal: ['internal'],
  response: [
    'template_response_claim',
    'template_outgoing_claim',
    'template_protocol_disagreement',
    'template_lawsuit',
  ],
  rules: ['checklist'],
};
